import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import SidebarItem from "./SidebarItem";
import "./Sidebar.scss";

const Sidebar = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [activeItem, setActiveItem] = useState("Dashboard");

  const location = useLocation();

  const menuItems = useMemo(
    () => [
      {
        name: "Dashboard",
        icon: "material-symbols-light:team-dashboard-outline-sharp",
        to: "/home/dashboard",
        notifications: 0,
      },
      {
        name: "Software Update",
        icon: "hugeicons:software",
        to: "/home/software-update/modules",
        notifications: 0,
        submenu: [
          { name: "Plans", to: "/home/software-update/plans" },
          { name: "Modules", to: "/home/software-update/modules" },
          { name: "Pricing", to: "/home/software-update/pricing" },
          { name: "Discounts", to: "/home/software-update/discounts" },
        ],
      },
      {
        name: "Tenant Manager",
        icon: "clarity:employee-group-line",
        to: "/home/tenant-manager",
        notifications: 0,
      },
      {
        name: "Bug Reports",
        icon: "mdi:bug-outline",
        to: "/home/bug-reports",
        notifications: 0,
      },
      {
        name: "Notification & Automation",
        icon: "mdi:bell-cog-outline",
        to: "/home/scheduled-automations",
        notifications: 0,
      },
    ],
    [],
  );

  useEffect(() => {
    const currentPath = location.pathname;
    let foundActiveItem = null;

    menuItems.forEach((item) => {
      if (item.to === currentPath) {
        foundActiveItem = item.name;
      } else if (item.submenu) {
        const activeSubmenuItem = item.submenu.find(
          (subItem) => subItem.to === currentPath,
        );
        if (activeSubmenuItem) {
          foundActiveItem = item.name;
        }
      }
    });

    setActiveItem(foundActiveItem || "Dashboard");
  }, [location, menuItems]);

  const handleClick = (name) => {
    setActiveItem(name);
  };

  return (
    <ul className="sidebar">
      {menuItems.map((item) => (
        <SidebarItem
          key={item.name}
          item={item}
          isHovered={hoveredItem === item.name}
          isActive={activeItem === item.name}
          onHover={setHoveredItem}
          onClick={() => handleClick(item.name)}
        />
      ))}
    </ul>
  );
};

export default Sidebar;
